"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isPromiseLike(arg) {
    return arg && arg.then !== undefined;
}
exports.isPromiseLike = isPromiseLike;



//////////////////
// WEBPACK FOOTER
// ./node_modules/xhr-mock/lib/isPromiseLike.js
// module id = 180
// module chunks = 0